"use strict";

define('rs/form/formobjects/person.finder/person.finder.formobject.view',['rs/form/formobjects/base.formobject.view', 'e3-common'], function (BaseFormObjectView, E3Common) {
  var AttachFormObjectView = BaseFormObjectView.extend({
    templates: {
      'person.finder.formobject': 'renderFormControls',
      'person.finder.formobject.pdf': 'renderFinderPDF'
    },
    events: {
      'click >.form-object-contents .btn-person-finder:not(.disabled)': 'handleFindBtnClick',
      'keydown >.form-object-contents .btn-person-finder:not(.disabled)': 'handleFindBtnKeydown',
      'click >.form-object-contents .open-person-training-cell': 'handleTrainingClick',
      'mouseover >.form-object-contents .btn-person-finder:not(.disabled)': 'handleFindBtnMouseOver',
      'mouseleave >.form-object-contents .btn-person-finder:not(.disabled)': 'handleFindBtnMouseLeave'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    refresh: function refresh() {
      this._super.apply(this, arguments);
      if (this.rendered) {
        this.refreshFormObjectWithValue();
      }
    },
    setupFormElement: function setupFormElement() {
      var delegate = this.getDelegate();
      delegate.view.$el.find(".btn-person-finder").attr("aria-label", delegate.getText().split(/<[^>]*>/).join('') + " Find People");
      if (delegate.hasAssignmentType()) {
        this.getContentElement().addClass('assignment-type-' + delegate.getAssignmentType());
      }
    },
    getPersonFinderDisplay: function getPersonFinderDisplay() {
      return this.$('.person-finder-display');
    },
    refreshFormValueForPDF: function refreshFormValueForPDF(el) {
      var container = el.find('> .form-object-contents .person-finder-display').parent(),
        delegate = this.getDelegate(),
        persons = delegate.getPersons() || [],
        data = delegate.getPDFDisplayData();
      container.removeClass();
      container.empty();
      if (persons.length) {
        container.append(this.renderFinderPDF(data));
      }
    },
    refreshFormObjectWithValue: function refreshFormObjectWithValue() {
      var container = this.getDisplayContainer(),
        delegate = this.getDelegate(),
        persons = delegate.getPersons() || [];
      if (persons.length) {
        container.show();
      } else {
        container.hide();
      }
      delegate.getDisplayTable().setFlag('forceRenderAll', true);
      delegate.getDisplayTable().getView().setElement(container);
      delegate.getDisplayTable().refresh();
      if (!delegate.getHasMultiple() && persons.length > 0 || delegate.isReadOnly() && !delegate.isDesignerMode()) {
        this.hideButton();
      } else {
        container.addClass('visible-finder');
        this.showButton();
      }
    },
    getDisplayContainer: function getDisplayContainer() {
      return this.$('.person-finder-display').css('min-width', 500);
    },
    hideButton: function hideButton() {
      this.$el.find('.btn-person-finder').hide();
    },
    showButton: function showButton() {
      this.$el.find('.btn-person-finder').show();
    },
    getValue: function getValue() {
      return this.formObjectValue && this.formObjectValue.length ? JSON.stringify(this.formObjectValue) : null;
    },
    handleFindBtnKeydown: function handleFindBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleFindBtnClick(ev);
      }
    },
    handleFindBtnClick: function handleFindBtnClick(ev) {
      this.getDelegate().requestPersonModal();
    },
    handleTrainingClick: function handleTrainingClick(event) {
      var email = $(event.target).closest('tr').find('[data-title="Email"]').text().trim();
      this.getDelegate().requestTrainingModal(email);
    },
    handleFindBtnMouseOver: function handleFindBtnMouseOver() {
      var delegate = this.getDelegate();
      delegate.view.$el.find('.btn-person-finder').html(delegate.getText().split(/<[^>]*>/).join('') + ' Find People');
    },
    handleFindBtnMouseLeave: function handleFindBtnMouseLeave() {
      var delegate = this.getDelegate();
      delegate.view.$el.find('.btn-person-finder').html(' Find People');
    }
  });
  return AttachFormObjectView;
});

